import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { WaveEyeSvg } from './svgs';

export const IconWaveEye: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={WaveEyeSvg} viewBox="0 0 56 56" {...props} />;
};
